const buildTabClassName = (tabIsSelected) => {
  let className = 'signups-tabs__tab';
  if (tabIsSelected) { className += ' signups-tabs__tab--selected'; }

  return className;
}

export default buildTabClassName;
